import { NgModule } from '@angular/core';

import { FormatCamelCaseToTextPipe } from './format-camel-case-to-text';

@NgModule({
  declarations: [FormatCamelCaseToTextPipe],
  exports: [FormatCamelCaseToTextPipe]
})
export class FormatCamelCaseToTextModule { }
